Storage = App.loadClass('core::Storage')

ScrollHelper = exports

ScrollHelper.make = (table, options = {}, with_dropdown = true, applypaddings = true) ->
    headheight = if table.find('thead').length then table.find('thead').outerHeight() else 0
    footheight = if table.find('tfoot').length then table.find('tfoot').outerHeight() else 0


    size = options.height - headheight - footheight
    defaultOptions =
        'sScrollY': size + 'px'
        'bDestroy': true
        'bPaginate': false
        'bFilter': false
        'bInfo': false
        'bSort': false

    opts = $.extend defaultOptions, options

    if table.hasClass 'dataTable'
        return

    table.dataTable opts


    if with_dropdown
        ScrollHelper.fixDropdownMenus table


ScrollHelper.fixDropdownMenus = (table) ->
    table.find('.dropdown-toggle').dropdown()
    table.find('.dropdown-toggle').click (e) ->
        offset = $(this).offset()
        offset.top += $(this).parents('div').height()

        bottom_diff = (offset.top + $(this).siblings('ul').outerHeight(true)) - $(document).height()

        # TODO: switch this so it positions above the button that opened it,
        # rather than flush with the bottom of the screen.
        if bottom_diff > 0
            offset.top = offset.top - bottom_diff

        right_diff = (offset.left + $(this).siblings('ul').outerWidth(true)) - $(document).width()

        if right_diff > 0
            offset.left = offset.left - $(this).siblings('ul').outerWidth(true) + $(this).outerWidth(true)
            #offset.left - right_diff

        $(this).siblings('ul').css
            position: 'fixed'
            top: "#{offset.top}px"
            left: "#{offset.left}px"
            width: "#{$(this).siblings('ul').outerWidth()}px"


        $(this).dropdown()
        e.stopPropagation()

### --------------------------------------------------------
    The following function:
        setSaveScroll/2

    exists to help solve an issue with scrolling tables in
    the sidebar. Whenever you do a data altering change
    such as deleting or renaming an item in the sidebar,
    the easiest way to reflect the change is to refresh the
    handler to re-list the items. This can be frustrating
    though, because it will reset the scrolling on the sidebar.

    setSaveScroll will try fetching an existing saved scroll
    position for the passed page, and then set the scrollTop
    on the table, and add a listener to update the stored
    value for retrieval later

    NOTE: the 'table' attribute may not be an actual table,
    it is just whatever element is actually technically
    scrollable
-------------------------------------------------------- ###

ScrollHelper.setSaveScroll = (page, table) ->
    scrollStorage = App.storage.retrieve 'handler_scrolling_position', new Storage()
    scrollPosition = scrollStorage.retrieve page, 0
    scrollStorage.empty()
    App.storage.store 'handler_scrolling_position', scrollStorage

    # This assumes we're using FHT
    table.prop('scrollTop', scrollPosition)
    table.off('scroll').on 'scroll', () ->
        App.storage.retrieve('handler_scrolling_position').store page, $(this).prop('scrollTop')
